// react core
import { useState, useEffect } from "react";

// imported animations
import Marquee from "react-fast-marquee";

// material design
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grow from "@mui/material/Grow";
import Typography from "@mui/material/Typography";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";
import { faInfoCircle as iconAbout } from "@fortawesome/pro-regular-svg-icons";
import { faSignIn as iconConnect } from "@fortawesome/pro-regular-svg-icons";
import { faMapPin as iconMapPin } from "@fortawesome/pro-duotone-svg-icons";

// entzy config models and components
import configEntzy from "components/config/ConfigEntzy";
import AboutExperiment from "components/about/AboutExperiment";

// import Hero from "components/utils/custom/CustomHero";
import { scrollSnapTop } from "services/tools";

// entzy assets
import imageHero0 from "assets/heros/map-signal-main.png";
// import imageHero1 from "assets/heros/tribe-finder-people.png";
// import imageHero2 from "assets/heros/events-bar.png";
// import imageHero3 from "assets/heros/calendar-confirmed.png";
// import imageHero4 from "assets/heros/tribe-finder-outdoor.png";

// import HomeSpotlight from "./HomeSpotlight";
import { ActionBoxButton } from "components/utils/common/CommonButtons";
import {
  TextTag,
  ModuleSubHeaderTag,
} from "components/utils/common/CommonTags";

// entzy assets
import BadgeGooglePlay from "assets/badges/google-play.png";
import BadgeAppleStore from "assets/badges/apple-store.svg";

const TAG_LIST = [
  "Live life local",
  "Tribalize by proximity",
  "Discover your community",
  "Build local connections",
  "Run repeat meets",
  "Create secret speakeasies",
  "Offer rooms as venues",
  "Share your skills",
  "Barter services",
  "Trade with each other",
  "Host events from home",
  "Create local economies",
  "Remove online dependency",
  "Shift buying power back home",
  "Support local businesses",
  "Move life offline",
];

function HomeLanding(props) {
  // const [start, setStart] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [heroTitle, setHeroTitle] = useState("Put your signal up");
  const [heroSubtitle, setHeroSubtitle] = useState("For human connection");

  // const handleToggleStart = () => {
  //   const element = document.getElementById("anchor-lets-go");
  //   if (element) scrollIntoViewIfNeeded(element);
  //   setStart(!start);
  // };

  const handleToggleShowAbout = () => {
    scrollSnapTop();
    setShowAbout(!showAbout);
  };
  const handleConnect = () => {
    props.drawerConnectToggle();
  };

  // effect to rotate the here title and subtitle through the worlds most spoken languages every 7 seconds
  useEffect(() => {
    const titles = [
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Ponga su señal", subtitle: "Para la conexión humana" }, // Spanish
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Mettez votre signal", subtitle: "Pour la connexion humaine" }, // French
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      {
        title: "Stellen Sie Ihr Signal ein",
        subtitle: "Für menschliche Verbindung",
      }, // German
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      {
        title: "Metti su il tuo segnale",
        subtitle: "Per la connessione umana",
      }, // Italian
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Coloque seu sinal", subtitle: "Para a conexão humana" }, // Portuguese
      { title: "Put your signal up", subtitle: "For human connection" }, // English
      { title: "Ustaw swój sygnał", subtitle: "Dla ludzkiego połączenia" }, // Polish
      // { title: "Put your signal up", subtitle: "For human connection" }, // English
      // { title: "Настройте свой сигнал", subtitle: "Для человеческой связи" }, // Russian
      // { title: "Put your signal up", subtitle: "For human connection" }, // English
      // { title: "Nastavite svoj signal", subtitle: "Za ljudsku povezanost" }, // Croatian
      // { title: "Put your signal up", subtitle: "For human connection" }, // English
      // { title: "放置信号", subtitle: "为了人类的联系" }, // Chinese (Simplified)
      // { title: "Put your signal up", subtitle: "For human connection" }, // English
      // { title: "シグナルを設定する", subtitle: "人間のつながりのために" }, // Japanese
      // { title: "Put your signal up", subtitle: "For human connection" }, // English
      // { title: "अपने सिग्नल सेट करें", subtitle: "मानव कनेक्शन के लिए" }, // Hindi
    ];
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % titles.length;
      setHeroTitle(titles[index].title);
      setHeroSubtitle(titles[index].subtitle);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box className="box-default">
      <Box
        className="box-default"
        sx={{
          pt: configEntzy.APP_SPACING_MD2X,
        }}
      >
        <Container maxWidth="md" disableGutters>
          <Box className="box-default" hidden={!showAbout}>
            <Box
              className="box-inline right action-pointer"
              sx={{
                mr: configEntzy.APP_SPACING_MD,
                width: configEntzy.AVATAR_SIZE_SM,
              }}
              onClick={handleToggleShowAbout}
            >
              <FontAwesomeIcon icon={iconClose} size="2x" />
            </Box>
            <AboutExperiment {...props} />
          </Box>
          <Box
            className="box-default nooverflow"
            sx={{
              pt: configEntzy.APP_SPACING_MD2X,
              px: configEntzy.APP_SPACING_MD2X,
              pb: configEntzy.APP_SPACING_MD2X,
            }}
            hidden={showAbout}
          >
            <Box className="box-default">
              <Typography
                variant="h6"
                color="white"
                align="center"
                className="glowing-text"
                sx={{
                  mb: configEntzy.APP_SPACING_MD,
                  letterSpacing: "0.3em",
                }}
              >
                ENTZY
              </Typography>
              <Typography variant="h3" color="white" align="center">
                Community Builder
              </Typography>
            </Box>
            <Box
              className="box-default text-paragraph"
              sx={{ mt: configEntzy.APP_SPACING_MD }}
            >
              <Container maxWidth="md">
                <Typography variant="h6" color="orange" align="center">
                  Find your tribe and create your own local economies with
                  simple repeat meets
                </Typography>
              </Container>
            </Box>

            <Box
              className="box-default"
              sx={{ mt: configEntzy.APP_SPACING_MD2X }}
            >
              <Box
                className="box-inline shadow-orange-glow action-pointfocus"
                sx={{
                  width: configEntzy.AVATAR_CONTAINER_LG,
                  height: configEntzy.AVATAR_CONTAINER_LG,
                  borderRadius: "50%",
                  backgroundImage: `url(${imageHero0})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                onClick={() => handleConnect()}
              ></Box>
            </Box>

            <Box
              key={heroTitle}
              className="box-default"
              sx={{
                mt: configEntzy.APP_SPACING_MD2X,
              }}
            >
              <Box className="box-inline">
                <Grow in={true} timeout={500}>
                  <Typography
                    variant="h3"
                    color="primary"
                    align="center"
                    sx={{ mb: configEntzy.APP_SPACING_SMd }}
                  >
                    {heroTitle}
                  </Typography>
                </Grow>
                <Grow in={true} timeout={2000}>
                  <Typography variant="h6" color="white" align="center">
                    {heroSubtitle}
                  </Typography>
                </Grow>
              </Box>
            </Box>

            <Box
              className="box-default"
              sx={{
                mt: configEntzy.APP_SPACING_MD,
              }}
            >
              <Typography
                variant="h6"
                color="white"
                align="center"
                className="glowing-text"
              >
                Summer 2026
              </Typography>
            </Box>
            <Box
              className="box-default"
              sx={{
                mt: configEntzy.APP_SPACING_MD,
              }}
            >
              <Typography variant="h6" color="white" align="center">
                Run events from anywhere
              </Typography>
              <Typography variant="h6" color="white" align="center">
                Get to know your neighbours
              </Typography>
            </Box>

            <Box
              className="box-default"
              sx={{
                mt: configEntzy.APP_SPACING_MD3X,
              }}
            >
              <Box
                className="box-default half-width"
                sx={{
                  pr: configEntzy.APP_SPACING_MD,
                }}
              >
                <ActionBoxButton
                  variant="contained"
                  size="large"
                  text={
                    <span>
                      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      Explore
                      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      <FontAwesomeIcon icon={iconAbout} />
                    </span>
                  }
                  bgColor="black"
                  color="white"
                  borderColor="purple"
                  onClick={() => handleToggleShowAbout()}
                />
              </Box>
              <Box
                className="box-default half-width"
                sx={{
                  pl: configEntzy.APP_SPACING_MD,
                }}
              >
                <ActionBoxButton
                  variant="contained"
                  size="large"
                  text={
                    <span>
                      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      Connect
                      <span>&nbsp;&nbsp;&nbsp;</span>
                      <FontAwesomeIcon icon={iconConnect} />
                    </span>
                  }
                  bgColor="black"
                  color="white"
                  borderColor="orange"
                  onClick={() => handleConnect()}
                />
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>

      <Box className="box-default" hidden={showAbout}>
        <Box
          className="box-default"
          sx={{
            mt: configEntzy.APP_SPACING_MD3X,
          }}
        >
          <ModuleSubHeaderTag text="Real life is local" />
        </Box>
        <Container maxWidth="md" disableGutters>
          <Box className="box-default">
            {/* -- first 8 tags from the list -- */}
            {Array.from({ length: 2 }).map((_, rowIndex) => (
              <Marquee
                key={rowIndex}
                gradient={false}
                speed={20 + rowIndex * 2}
                pauseOnHover={true}
                style={{ overflowX: "hidden" }}
                direction={rowIndex % 2 === 0 ? "left" : "right"}
              >
                {TAG_LIST.slice(rowIndex * 4, rowIndex * 4 + 4).map(
                  (tag, index) => (
                    <TextTag
                      key={index}
                      text={tag}
                      size="md"
                      bgColor={
                        index % 4 === 0
                          ? "purple"
                          : index % 4 === 1
                            ? "primary.dark"
                            : index % 4 === 2
                              ? "blue"
                              : "green"
                      }
                      color="white"
                      margin={true}
                      edges={true}
                      borderRadius="16px"
                      noMask={true}
                      textNoCasing={true}
                      onClick={() => handleToggleShowAbout()}
                    />
                  ),
                )}
              </Marquee>
            ))}
          </Box>

          <Box
            className="box-default"
            sx={{
              mt: configEntzy.APP_SPACING_MD3X,
              px: configEntzy.APP_SPACING_MD2X,
            }}
          >
            <Box
              className="box-inline bg-black shadow-purple-glow action-pointfocus"
              sx={{
                py: configEntzy.APP_SPACING_MD2X,
                px: configEntzy.APP_SPACING_MD2X,
                borderRadius: "12rem",
              }}
              onClick={() => handleConnect()}
            >
              <Box className="box-default relative zero-height pop-up text-right">
                <FontAwesomeIcon
                  icon={iconMapPin}
                  size="5x"
                  color="magenta"
                  transform="rotate-20 up-10 right-12"
                />
              </Box>
              <Box className="box-default text-paragraph">
                <Typography
                  variant="subtitle2"
                  color="primary"
                  className="upper-case"
                >
                  How to Start
                </Typography>
                <Typography variant="subtitle2" color="white">
                  Connect to Entzy and add yourself to the map to tribalize.
                  That's it for now. Put your hand up to signal a summer outside
                  and a technology reset. Let's find 3rd spaces, meet people and
                  rebuild next door communities.
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            className="box-default"
            sx={{
              mt: configEntzy.APP_SPACING_MD3X,
            }}
          >
            {/* -- second 8 tags from the list -- */}
            {Array.from({ length: 2 }).map((_, rowIndex) => (
              <Marquee
                key={rowIndex}
                gradient={false}
                speed={20 + rowIndex * 2}
                pauseOnHover={true}
                style={{ overflowX: "hidden" }}
                direction={rowIndex % 2 === 0 ? "left" : "right"}
              >
                {TAG_LIST.slice(8 + rowIndex * 4, 8 + rowIndex * 4 + 4).map(
                  (tag, index) => (
                    <TextTag
                      key={index}
                      text={tag}
                      size="md"
                      bgColor={
                        index % 4 === 0
                          ? "purple"
                          : index % 4 === 1
                            ? "primary.dark"
                            : index % 4 === 2
                              ? "blue"
                              : "green"
                      }
                      color="white"
                      margin={true}
                      edges={true}
                      borderRadius="16px"
                      noMask={true}
                      textNoCasing={true}
                      onClick={() => handleToggleShowAbout()}
                    />
                  ),
                )}
              </Marquee>
            ))}
          </Box>
        </Container>
      </Box>

      <Box
        className="box-default footer-height"
        sx={{
          mt: configEntzy.APP_SPACING_HL,
        }}
      >
        <ModuleSubHeaderTag text="App Downloads" />
        <Box className="box-inline">
          <Box
            className="box-default half-width"
            sx={{ p: configEntzy.APP_SPACING_SM }}
          >
            <a
              href={
                "https://apps.apple.com/us/app/entzy/id1543725422?ct=" +
                configEntzy.APP_DOMAIN
              }
              target="_blank"
              rel="noopener noreferrer"
              className="image-link"
            >
              <img
                alt="Download on the App Store"
                src={BadgeAppleStore}
                className="app-badge-apple"
              />
            </a>
          </Box>
          <Box
            className="box-default half-width"
            sx={{ p: configEntzy.APP_SPACING_SM }}
          >
            <a
              href={
                "https://play.google.com/store/apps/details?id=com.entzy.twa&utm_source=" +
                configEntzy.APP_DOMAIN
              }
              target="_blank"
              rel="noopener noreferrer"
              className="image-link"
            >
              <img
                alt="Get it on Google Play"
                src={BadgeGooglePlay}
                className="app-badge-google"
              />
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default HomeLanding;
